import {registerTemplateGraphNode} from "#template/template-node/register"
import {meshGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {MeshGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {SubdivideOperatorParameters} from "#template/nodes/geometry-graph/attribute-set/subdivide-operator/geometry-subdivide-operator-node"
import {
    GeometrySubdivideOperatorNode,
    subdivideOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/subdivide-operator/geometry-subdivide-operator-node"

const definition: TemplateNodeDefinition<SubdivideOperatorParameters> = {
    nodeClass: "MeshGeometrySubdivideOperator",
    validation: {
        parameters: subdivideOperatorParametersSchema,
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometrySubdivideOperator extends GeometrySubdivideOperatorNode implements MeshGeometryAttributeSetLikeNode {
    get [meshGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
